<template>
    <button
        class="cz2__kiosk-restart"
        v-if="shouldShowKioskRestartButton"
        @click="restart"
        @blur="stopPress"
        @mousedown="startPress"
        @mouseup="stopPress"
        @mouseleave="stopPress"
        @touchstart.prevent="startPress"
        @touchend.prevent="stopPress"
    />
</template>

<style lang="scss">
    #cz2.cz2.cz2__is-kiosk {
        .cz2__kiosk-restart{
            position: absolute;
            height: 144px;
            width: 144px;
            top: 0;
            left: 0;
            z-index: 100000;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                isPressed: false,
            };
        },
        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            inspectModalShown() {
                return this.$store.state.inspectModalShown;
            },

            timeoutShown() {
                return this.$store.state.timeoutShown;
            },

            kioskRestartShown() {
                return this.$store.state.kioskRestartShown;
            },

            serviceMenuShown() {
                return this.$store.state.serviceMenuShown;
            },

            printingShown() {
                return this.$store.state.printingShown;
            },

            printingErrorShown() {
                return this.$store.state.printingErrorShown;
            },

            saveErrorShown() {
                return this.$store.state.saveErrorShown;
            },

            changeWarningShown() {
                return this.$store.state.changeWarningShown;
            },

            outOfStockWarningShown() {
                return this.$store.state.outOfStockWarningShown;
            },

            protectorUpsellShown() {
                return this.$store.state.protectorUpsellShown;
            },

            switchPopModalShown() {
                return this.$store.state.switchPopModalShown;
            },

            isOpenAnyModal() {
                return this.inspectModalShown
                    || this.timeoutShown
                    || this.kioskRestartShown
                    || this.serviceMenuShown
                    || this.printingShown
                    || this.printingErrorShown
                    || this.saveErrorShown
                    || this.changeWarningShown
                    || this.outOfStockWarningShown
                    || this.protectorUpsellShown
                    || this.switchPopModalShown;
            },

            shouldShowKioskRestartButton() {
                if (!this.isKiosk || this.inspectModalShown || this.isOpenAnyModal) {
                    return false;
                }

                return true;
            },
        },

        methods: {
            startPress() {
                if (this.timer) {
                    clearTimeout(this.timer);
                }

                this.timer = setTimeout(() => {
                    this.handleLongPress();
                }, 3000);
            },

            stopPress() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
            },

            handleLongPress() {
                this.$store.dispatch('showKioskRestartWarning', true);
            },

            restart() {
                // window.location.reload();
            },
        },
    };
</script>
